<template>
  <section class="content-wrapper">
    <h1 class="title">{{ $t('frequently-asked-questions') }}</h1>
    <div class="break-line"></div>
    <template v-if="faqCategories.length > 0">
      <div class="faq-content-wrapper">
        <div class="category-list-wrapper">
          <!--          pc端category样式-->
          <nav class="category-list">
            <ul>
              <li
                v-for="(item, index) in faqCategories"
                :key="index"
                @click="handleCategoryItemClick(item, index)"
                :class="['category-item', { 'category-item-click': categoryItemClick === index }]"
              >
                {{ item }}
              </li>
            </ul>
            <div class="email-us">
              {{ $t('didn’t-find-an-answer?') }}
              <span class="link" @click.prevent="goToEnquiryPage">{{ $t('email-us') }}</span>
            </div>
          </nav>
        </div>
        <div class="pc">
          <div class="category-faq-item-wrapper">
            <div v-for="(item, index) in filterFAQ" :key="index">
              <div class="category-faq-item" @click="clickArrow(index)">
                {{ item.title }}
                <div :class="['arrow-down', { 'arrow-up': isArrowUp === index }]" />
              </div>
              <div class="faq-answer-wrapper" v-show="isShowContext === index">
                <div class="faq-answer" v-html="item.context" />
              </div>
              <div class="faq-break-line"></div>
            </div>
          </div>
        </div>
        <div class="mobile">
          <!--          类别-->
          <ul class="mobile-category-wrapper">
            <li class="mobile-category" v-for="(i, _) in faqCategories" :key="_">
              <div class="mobile-category-header" @click="mobileToggleCategoryItem(_)">
                <div class="mobile-current-category-name">{{ i }}</div>
                <div
                  :class="[
                    'mobile-arrow-down',
                    { 'mobile-arrow-up': isShowMobileCategoryItem === _ },
                  ]"
                ></div>
              </div>
              <!--          类别下的faq-->
              <div class="category-faq-item-wrapper" v-show="isShowMobileCategoryItem === _">
                <div v-for="(item, index) in filterFAQ" :key="index">
                  <div class="category-faq-item" @click="clickArrow(index)">
                    {{ item.title }}
                    <div :class="['arrow-down', { 'arrow-up': isArrowUp === index }]" />
                  </div>
                  <div class="faq-answer-wrapper" v-show="isShowContext === index">
                    <div class="faq-answer" v-html="item.context" />
                  </div>
                  <div class="faq-break-line"></div>
                </div>
              </div>
            </li>
          </ul>
          <div class="email-us">
            {{ $t('didn’t-find-an-answer?') }}
            <span class="link" @click.prevent="goToEnquiryPage">{{ $t('email-us') }}</span>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Faqs',

    data() {
      return {
        categoryItemClick: '',
        faqCategories: [],
        isArrowUp: false,
        faqQaA: [],
        isShowContext: '',
        filterFAQ: [],
        currentDpid: '',
        emailTo: '',
        isShowTerminalDropDownList: false,
        currentCategoryItem: '',
        isShowMobileCategoryItem: [],
        faqFreshDeskHandle: {
          /* eslint camelcase: ["error", {properties: "never"}] */
          en_US: {
            local: [
              {
                keyword: 'Get In Touch',
                codeList: [
                  'FAQ00003084',
                  'FAQ00003078',
                  'FAQ00003095',
                  'FAQ00000003454',
                  'FAQ00000006032',
                ],
              },
            ],
            test: [],
            uat: [
              {
                keyword: 'Get In Touch',
                codeList: [
                  'FAQ00003084',
                  'FAQ00003078',
                  'FAQ00003095',
                  'FAQ00000003454',
                  'FAQ00000006032',
                ],
              },
            ],
            production: [
              {
                keyword: 'Get In Touch',
                codeList: [
                  'FAQ00000007096',
                  'FAQ00000007122',
                  'FAQ00000007073',
                  'FAQ00000007103',
                  'FAQ00000007812',
                ],
              },
            ],
          },
          fr_CA: {
            local: [
              {
                keyword: 'Nous joindre',
                codeList: [
                  'FAQ00000006058',
                  'FAQ00000006068',
                  'FAQ00000006080',
                  'FAQ00000006103',
                  'FAQ00000006120',
                ],
              },
            ],
            test: [],
            uat: [
              {
                keyword: 'Nous joindre',
                codeList: [
                  'FAQ00000006058',
                  'FAQ00000006068',
                  'FAQ00000006080',
                  'FAQ00000006103',
                  'FAQ00000006120',
                ],
              },
            ],
            production: [
              {
                keyword: 'Nous joindre',
                codeList: [
                  'FAQ00000007989',
                  'FAQ00000007999',
                  'FAQ00000008011',
                  'FAQ00000008034',
                  'FAQ00000008050',
                ],
              },
            ],
          },
        },
      };
    },

    mounted() {
      this.fetchFaqs();
    },

    methods: {
      editDomTree() {
        const dom = document.querySelectorAll('.faq-answer');
        if (dom && dom.length) {
          dom.forEach(i => {
            // 递归ol元素
            this.editDomOL(i);
          });
        }
      },
      editDomOL(dom) {
        const domChildren = dom.children;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < domChildren.length; i++) {
          // 如果当前元素是ol或者ul 递归调用
          if (domChildren[i].tagName === 'OL' || domChildren[i].tagName === 'UL') {
            this.editDomOL(domChildren[i]);
            // 判断当前元素是否有上一个兄弟li元素
            if (
              domChildren[i].previousElementSibling &&
              domChildren[i].previousElementSibling.tagName === 'LI'
            ) {
              // 如果有，将当前元素插入到上一个兄弟li元素中
              domChildren[i].previousElementSibling.appendChild(domChildren[i]);
            }
          }
        }
      },
      fetchFaqs() {
        const data = { lang: this.$i18n.locale, userId: this.userInfo?.userId };
        this.$http.common.getFAQContent(data).then(res => {
          this.faqCategories = [...new Set(res.list.map(item => item.type))];
          // console.log(this.faqCategories)
          this.faqQaA = this.transformFaq(res.list);
          // 默认选中第一种
          this.currentCategoryItem = this.faqCategories[0];
          // eslint-disable-next-line array-callback-return
          this.filterFAQ = this.faqQaA.filter(_ => {
            return _.type === this.currentCategoryItem;
          });
          this.categoryItemClick = 0;
        });
        // email us 需要带上用户dpid，需要调dpid接口
        if (this.userInfo) {
          const data2 = {
            userId: this.userInfo?.userId,
            device: 'web',
            version: '1.0.0',
            lang: this.$i18n.locale,
            sessionId: this.userInfo?.sessionId,
          };
          this.$http.member.getAccountList(data2).then(res => {
            if (res?.state === '11') {
              // this.currentDpid = res?.list[0]?.dragoncode;
              this.currentDpid = res?.payload[0]?.dragonCode;
              this.emailTo = `mailto:ca.support@dragonpassuk.com?subject=Enquiry or Feedback ${this.currentDpid?.replace(
                /(\d{4})/g,
                '$1 ',
              )}`;
            }
          });
        } else {
          this.emailTo = 'mailto:ca.support@dragonpassuk.com?subject=Enquiry or Feedback';
        }
      },

      categoryToggleDropDownList() {
        this.isShowTerminalDropDownList = !this.isShowTerminalDropDownList;
      },
      handleCategoryItemClick(item, index) {
        this.categoryItemClick = index;
        this.currentCategoryItem = this.faqCategories[index];
        //  过滤特定category下的faq
        this.filterFAQ = this.faqQaA.filter(i => i.type === item);
      },

      mobileHandleCategoryItemClick(item) {
        this.categoryItemClick = item[1];
        //  过滤特定category下的faq
        this.filterFAQ = this.faqQaA.filter(i => i.type === item[0]);
      },
      mobileToggleCategoryItem(index) {
        console.log('asd', index);
        if (this.isShowMobileCategoryItem === index) {
          this.isShowMobileCategoryItem = null;
          return;
        }
        this.isShowMobileCategoryItem = index;
        this.filterFAQ = this.faqQaA.filter(i => i.type === this.faqCategories[index]);
      },
      clickArrow(index) {
        if (this.isArrowUp === index) {
          this.isArrowUp = null;
          this.isShowContext = null;
          return;
        }
        this.isArrowUp = index;
        this.isShowContext = index;
      },
      getEnv() {
        return process.env.VUE_APP_CUSTOM_ENV;
      },
      transformFaq(faqlist) {
        const lang = this.$i18n.locale;
        const env = this.getEnv();
        const faqFreshDeskMapArray = this.faqFreshDeskHandle[lang || 'en_US']?.[env] || [];
        let newStrList = [...faqlist];
        faqFreshDeskMapArray.forEach(strMap => {
          const { codeList = [], keyword = '' } = strMap;
          newStrList = newStrList.map(i => {
            if (codeList.includes(i.id)) {
              i.context = i.context.replaceAll(
                keyword,
                `<a href='/feedback' style="text-decoration: underline;cursor: pointer;">${keyword}</a>`,
              );
            }
            return i;
          });
        });
        return newStrList;
      },
      goToEnquiryPage() {
        if (!this.isLogin) {
          this.$router.push({
            path: '/feedback',
          });
        } else {
          this.$router.push({
            path: '/account/contact',
          });
        }
      },
    },

    computed: {
      ...mapState(['userInfo', 'isLogin']),
    },

    watch: {
      // faqQaA: {
      //   handler(newVal) {
      //     this.filterFAQ = newVal;
      //   },
      // },
      filterFAQ: {
        handler() {
          this.$nextTick(() => {
            this.editDomTree();
          });
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use 'index';
</style>
